//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClipboardJS from 'clipboard';
import { cloudFileSetupApi } from '@/api/config';
import { configUpdateDataApi } from '@/api/setting';
import { appConfigApi } from '@/api/public';
export default {
  name: 'CloudFile',
  components: {},
  props: {
    rule: {
      type: Array,
      default: function _default() {
        ;
        [];
      }
    }
  },
  data: function data() {
    return {
      form: {
        wps_type: 0,
        wps_appid: '',
        wps_appkey: '',
        address: location.protocol + '//' + location.host
      },
      rules: {
        wps_type: [{
          required: true,
          message: '请输入wps_type',
          trigger: 'change'
        }],
        wps_appid: [{
          required: true,
          message: '请输入APPID',
          trigger: 'blur'
        }],
        wps_appkey: [{
          required: true,
          message: '请输入APPKEY',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: '请输入网站地址',
          trigger: 'blur'
        }]
      },
      loading: false
    };
  },
  watch: {
    rule: {
      handler: function handler(val) {
        var _this = this;
        if (val.length) {
          val.map(function (e) {
            _this.form[e.field] = e.value;
          });
        }
      }
    }
  },
  mounted: function mounted() {
    this.getConfigData();
  },
  methods: {
    submitForm: function submitForm() {
      var _this2 = this;
      var data;
      if (this.form.wps_type == 1) {
        data = {
          wps_type: this.form.wps_type
        };
      } else {
        this.$refs.form.validate(function (valid) {
          if (valid) {
            data = {
              wps_type: _this2.form.wps_type,
              wps_appid: _this2.form.wps_appid,
              wps_appkey: _this2.form.wps_appkey
            };
          }
        });
      }
      this.setup('wps_config', data);
    },
    copy: function copy() {
      var _this3 = this;
      this.$nextTick(function () {
        var clipboard = new ClipboardJS('.copy-data');
        clipboard.on('success', function () {
          _this3.$message.success(_this3.$t('setting.copytitle'));
          clipboard.destroy();
        });
      });
    },
    getConfigData: function getConfigData() {
      // configUpdateDataApi({ cate_id: 4 }).then((res) => {
      //   const data = res.data.rule
      //   this.form.appId = data[0].value
      //   this.form.appKey = data[1].value
      // })
    },
    setup: function setup(id, data) {
      var _this4 = this;
      this.loading = true;
      cloudFileSetupApi(id, data).then(function (res) {
        _this4.getConfig();
        _this4.loading = false;
        // this.fromData = res.data;
      }).catch(function (err) {
        _this4.loading = false;
      });
    },
    getConfig: function getConfig() {
      appConfigApi().then(function (res) {
        localStorage.setItem('isWebConfig', res.data.global_watermark_status);
        localStorage.setItem('webConfig', JSON.stringify(res.data));
      });
    }
  }
};